export const RCS_SAMPLE_HELP_TEMPLATE =
  'You are chatting with {org_name}. For help, reply HELP or email us at example@example.com. Msg&Data Rates May Apply. Message frequency varies.'

export const RCS_SAMPLE_OPT_OUT_TEMPLATE =
  'You have successfully been unsubscribed. You will not receive any more messages from {org_name}. Reply START to resubscribe.'

export const RCS_ORGANIZATION_NAME_FALLBACK = 'our team'
